export enum FeedItemType {
  Post            = 1,
  NewsArticle     = 2,
  SuggestedTopics = 3,
  Video           = 4,
  ArticlePost     = 5,
}